import { DEFAULT_MIME } from 'components/common/UploadModal/utils/getContentType';
import { restClient } from 'config/store/configureStore';
import { MODELS_URL, MODELS_FILTER_URL, MODELS_SEARCH_FIND_BY_ID_URL, MODELS_UPDATE_URL } from 'constants/ApiConstants';

import { resolveLink } from '../UrlResolver';

const updateModelsWithXml = xmlFile =>
  restClient.post(MODELS_UPDATE_URL, xmlFile, {
    headers: { 'Content-Type': xmlFile.type },
  });

const updateModelsWithZip = zipFile => {
  const headers = { 'Content-Type': DEFAULT_MIME };
  restClient.post(MODELS_UPDATE_URL, zipFile, {
    headers,
  });
};

export default {
  getModels: (links, parameters) => {
    const filterUrl = MODELS_FILTER_URL;
    const { url, params } = resolveLink(links, filterUrl, parameters);
    return restClient.get(url, { params });
  },

  getModel: (modelId, params) =>
    restClient.get(MODELS_SEARCH_FIND_BY_ID_URL, {
      params: { id: modelId, ...params },
    }),

  getDerivative: (modelId, derivativeCode, params) =>
    restClient.get(`${MODELS_URL}/${modelId}/derivatives/${derivativeCode}`, {
      params,
    }),

  getVariant: (modelId, derivativeCode, variantCode, tvaCode, params) =>
    restClient.get(`${MODELS_URL}/${modelId}/derivatives/${derivativeCode}/variants/${variantCode}/tva/${tvaCode}`, {
      params,
    }),

  uploadModels: modelsFile =>
    (modelsFile.type === 'text/xml' ? updateModelsWithXml(modelsFile) : updateModelsWithZip(modelsFile)),

  updateModel: model => restClient.patch(`${MODELS_URL}/${model.id}`, model),
};
